import { render, staticRenderFns } from "./iconCellphone.vue?vue&type=template&id=de1df71e"
import script from "./iconCellphone.vue?vue&type=script&lang=js"
export * from "./iconCellphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports